var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.335 13l1.405-1.441-3.937-4.04H34V5.481H3.804l3.937-4.04L6.335 0 0 6.499 6.335 13z"}));
}

ArrowLeft.defaultProps = {"width":"34","height":"13"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
